/**
 * Feature Flags Configuration
 *
 * Allows toggling between old and new architecture implementations
 *
 * Usage in .env.local:
 * REACT_APP_USE_NEW_ARCHITECTURE=true   # Use new HTTP-based architecture
 * REACT_APP_USE_NEW_ARCHITECTURE=false  # Use old Storage-based architecture
 *
 * To enable feature flag:
 * 1. Create/update .env.local file in project root
 * 2. Add: REACT_APP_USE_NEW_ARCHITECTURE=true
 * 3. Restart development server
 *
 * For production testing:
 * - Set environment variable in Firebase Hosting configuration
 * - Or rebuild with appropriate .env file
 */

const FEATURE_FLAGS = {
  // New HTTP-based architecture (2 functions, no Storage triggers)
  USE_NEW_HTTP_ARCHITECTURE: process.env.REACT_APP_USE_NEW_ARCHITECTURE === 'true',
};

/**
 * Check if new HTTP architecture is enabled
 * @returns {boolean}
 */
export const isNewArchitectureEnabled = () => {
  const enabled = FEATURE_FLAGS.USE_NEW_HTTP_ARCHITECTURE;

  // Log once on load for debugging
  if (!window.__featureFlagsLogged) {
    console.log('🚀 Feature Flags:', {
      useNewArchitecture: enabled,
      env: process.env.REACT_APP_USE_NEW_ARCHITECTURE,
      mode: enabled ? 'HTTP Upload (New)' : 'Storage Upload (Legacy)'
    });
    window.__featureFlagsLogged = true;
  }

  return enabled;
};

/**
 * Get Cloud Function URL based on environment
 * @param {string} functionName - Name of the function
 * @returns {string} Full Cloud Function URL
 */
export const getCloudFunctionURL = (functionName) => {
  // In development, you may need to use emulator URLs
  const useEmulator = process.env.REACT_APP_USE_EMULATOR === 'true';

  if (useEmulator) {
    return `http://localhost:5001/${process.env.REACT_APP_FIREBASE_PROJECT_ID}/us-central1/${functionName}`;
  }

  // Production Cloud Function URL
  // Format: https://REGION-PROJECT_ID.cloudfunctions.net/FUNCTION_NAME
  const region = process.env.REACT_APP_FUNCTIONS_REGION || 'us-central1';
  const projectId = process.env.REACT_APP_FIREBASE_PROJECT_ID || 'pdf-statement-converter-net';

  return `https://${region}-${projectId}.cloudfunctions.net/${functionName}`;
};

export default FEATURE_FLAGS;
